import React from 'react'

import { cn } from '@utils/mergeClassNames'

interface DotsLoaderProps {
  className?: string
}

/**
 * Two-dot button loader (MIRA-4295 design: "•● Delete"). The dots take the
 * button's text color and pulse in turn.
 */
export function DotsLoader({ className }: DotsLoaderProps) {
  return (
    <span aria-hidden="true" className={cn('dots-loader', className)}>
      <span />
      <span />
    </span>
  )
}
